/* ============================================================
   ww-alt.js - fills in missing image alt text, site-wide.
   Shopify only renders alt for images that have it set in the admin; many supplier images don't.
   The theme's own product images get a Liquid fallback (product-images / product-thumbnail);
   this covers everything rendered by scripts (Convermax product grids, apps) and anything missed:
   alt = the product title from the same card, plus "Wheelwiz". Runs again as grids re-render.
   ============================================================ */
(function () {
  'use strict';
  if (window.__wwAlt) return; window.__wwAlt = true;

  function titleFor(img) {
    /* nearest ancestor that links to one product → its visible title, else the page's product title */
    for (var el = img.parentElement, depth = 0; el && depth < 8; el = el.parentElement, depth++) {
      var links = el.querySelectorAll('a[href*="/products/"]');
      if (!links.length) continue;
      var h = (links[0].getAttribute('href') || '').replace(/[?#].*$/, '');
      var same = true;
      for (var i = 1; i < links.length; i++) { if ((links[i].getAttribute('href') || '').replace(/[?#].*$/, '') !== h) { same = false; break; } }
      if (!same) break;
      for (var j = 0; j < links.length; j++) {
        var t = (links[j].textContent || '').trim();
        if (t.length > 3 && t.length < 160 && !/^\$/.test(t)) return t;
      }
      var t2 = links[0].getAttribute('title') || links[0].getAttribute('aria-label');
      if (t2) return t2.trim();
    }
    var meta = window.wwProductMeta;
    if (meta && document.body.classList.contains('template-product')) {
      var h1 = document.querySelector('h1');
      if (h1) return h1.textContent.trim();
    }
    return '';
  }

  /* product grids: the plain "SALE" label becomes a red pill (styled in custom.css) */
  function badges(root) {
    var els = root.querySelectorAll ? root.querySelectorAll('.cmTemplate_product *:not([data-ww-badge]), .product-item *:not([data-ww-badge])') : [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;
      el.setAttribute('data-ww-badge', '1');
      var t = (el.textContent || '').trim().toLowerCase();
      if (t === 'sale' || t === 'solde' || t === 'en solde' || t === 'on sale') el.classList.add('ww-badge-sale');
    }
  }

  function fix(root) {
    badges(root);
    var imgs = (root.querySelectorAll ? root.querySelectorAll('img:not([data-ww-alt])') : []);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('data-ww-alt', '1');
      var alt = (img.getAttribute('alt') || '').trim();
      if (alt) continue;
      if (img.width && img.width < 24 && img.height && img.height < 24) continue;     /* icons */
      var t = titleFor(img);
      if (t) img.setAttribute('alt', t + ' | Wheelwiz');
    }
  }

  /* Vehicle strings from Convermax sometimes repeat the trim ("Model 3 Long Range Long Range") when Submodel and
     Option carry the same value. Collapse an immediately repeated phrase wherever a vehicle name is printed. */
  function dedupeVehicle(root) {
    var els = root.querySelectorAll ? root.querySelectorAll('.cm_verify-fitment_vehicle, .cm_vehicle-widget_title, .ww-kitbar__vehicle, .ww-kitbar__chosen, .ww-veh-line, .ww-veh-name, .ww-fitment-badge, [data-ww-vehicle]') : [];
    for (var i = 0; i < els.length; i++) {
      var w = document.createTreeWalker(els[i], NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var t = n.textContent, u = t.replace(/\b((?:[A-Za-z0-9.\-\/]+\s+){0,3}[A-Za-z0-9.\-\/]+)\s+\1\b/g, '$1');
        if (u !== t) n.textContent = u;
      }
    }
  }
  /* ---- Convermax French labels (2026-09-24) ---- */
  var WW_FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  /* Convermax prints some strings in English on the French store, and a few of its own FR labels are wrong
     ("Faire" for Make). Swap the known ones wherever a Convermax widget renders: the fitment box, the YMM bar,
     the collection-page vehicle selector. Exact-match on trimmed text, placeholders, first <option>, aria-labels. */
  var CM_FR_TEXT = {
    'This product DOES NOT Fit or may be too aggressive for your': 'Ce produit NE CONVIENT PAS ou pourrait \u00eatre trop agressif pour votre',
    'This product does not fit your': 'Ce produit ne convient pas \u00e0 votre',
    'This Product Fits Your': 'Ce produit convient \u00e0 votre',
    'This is an aggressive fitment for your': 'Monte agressive pour votre',
    'View Wheels that fit this vehicle': 'Voir les roues compatibles',
    'View Tires that fit this vehicle': 'Voir les pneus compatibles',
    'View on vehicle': 'Voir sur le v\u00e9hicule', 'View On Vehicle': 'Voir sur le v\u00e9hicule', 'VIEW ON VEHICLE': 'Voir sur le v\u00e9hicule',
    'Verify fitment with your vehicle': 'V\u00e9rifiez la compatibilit\u00e9 avec votre v\u00e9hicule',
    'Search by vehicle': 'Rechercher par v\u00e9hicule',
    'Go': 'OK', 'GO': 'OK', 'Clear': 'Effacer', 'CLEAR': 'Effacer',
    'Make': 'Marque', 'Faire': 'Marque',
    'Year': 'Ann\u00e9e', 'Model': 'Mod\u00e8le', 'Submodel': 'Sous-mod\u00e8le',
    'Select Year': 'Ann\u00e9e', 'Select Make': 'Marque', 'Select Model': 'Mod\u00e8le', 'Select Submodel': 'Sous-mod\u00e8le', 'Select Option': 'Option',
    'Search': 'Rechercher', 'Search\u2026': 'Rechercher\u2026', 'Search...': 'Rechercher...',
    'Change': 'Changer', 'Add vehicle': 'Ajouter un v\u00e9hicule', 'My garage': 'Mon garage', 'Garage': 'Garage'
  };
  var CM_FR_LC = {}; Object.keys(CM_FR_TEXT).forEach(function (k) { CM_FR_LC[k.toLowerCase()] = CM_FR_TEXT[k]; });
  function cmFr(t) { t = String(t || '').replace(/\s+/g, ' ').trim().toLowerCase(); return Object.prototype.hasOwnProperty.call(CM_FR_LC, t) ? CM_FR_LC[t] : null; }
  function translateWidget() {
    if (!WW_FR) return;
    var roots = document.querySelectorAll('#cm_verify-fitment, .cm_vehicle-widget, [class*="cm_ymm"], #cm-ymm, #cm-garage, #cm-mobile-garage, .cm_garage, #cm-search-box');
    [].forEach.call(roots, function (root) {
      /* text-only elements */
      [].forEach.call(root.querySelectorAll('*'), function (el) {
        if (el.textContent && (el.children.length === 0 || (el.matches('button, a') && el.querySelectorAll('img, svg').length === 0 && el.children.length < 3))) { var r = cmFr(el.textContent); if (r && el.textContent.trim() !== r) el.textContent = r; }
        var ph = el.getAttribute && el.getAttribute('placeholder'); if (ph) { var rp = cmFr(ph); if (rp && ph !== rp) el.setAttribute('placeholder', rp); }
        var al = el.getAttribute && el.getAttribute('aria-label'); if (al) { var ra = cmFr(al); if (ra && al !== ra) el.setAttribute('aria-label', ra); }
      });
      /* native selects: the placeholder is the first option */
      [].forEach.call(root.querySelectorAll('select'), function (sel) {
        var o = sel.options && sel.options[0]; if (!o) return;
        var ro = cmFr(o.textContent); if (ro && o.textContent !== ro) o.textContent = ro;
      });
    });
  }

  function run() { fix(document); dedupeVehicle(document); translateWidget(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) if (a[j].nodeType === 1) { fix(a[j]); dedupeVehicle(a[j]); }
    }
    if (WW_FR) { clearTimeout(window.__wwCmFrT); window.__wwCmFrT = setTimeout(translateWidget, 120); }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['placeholder', 'aria-label'] });
})();

/* ---------- Pill tooltips: tap to open on phones, tap elsewhere / Esc to close ----------
   Desktop hover is pure CSS (.ww-pill--tip:hover). Bubbles near the right edge flip to open leftwards. */
(function () {
  if (window.__wwPillTips) return; window.__wwPillTips = true;
  function closeAll(except) {
    var open = document.querySelectorAll('.ww-pill--tip.is-open');
    for (var i = 0; i < open.length; i++) if (open[i] !== except) { open[i].classList.remove('is-open'); open[i].setAttribute('aria-expanded', 'false'); }
  }
  function side(pill) {
    var r = pill.getBoundingClientRect();
    pill.classList.toggle('ww-pill--tip-right', r.left + 280 > window.innerWidth && r.right > 280);
  }
  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('.ww-pill--tip');
    if (!pill) { closeAll(); return; }
    if (pill.closest('a')) return;                         /* a pill inside a link keeps the link */
    e.preventDefault();
    closeAll(pill);
    side(pill);
    var on = !pill.classList.contains('is-open');
    pill.classList.toggle('is-open', on);
    pill.setAttribute('aria-expanded', on ? 'true' : 'false');
  });
  document.addEventListener('mouseover', function (e) {
    var pill = e.target.closest && e.target.closest('.ww-pill--tip');
    if (pill) side(pill);
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('ww-pill--tip')) { e.preventDefault(); e.target.click(); }
  });
})();

/* ---------- Tiles with a "Shop now" button: the whole tile is the link (2026-09-26) ----------
   Used on /pages/accessory-types (Car care · TPMS · Installation kits · Lock nuts). Works whatever renders
   the tiles (theme section or Convermax): for every "Shop now" link on a page template, the nearest
   ancestor that contains only that one link (the picture, title and text above it) becomes clickable.
   Modifier / middle clicks still open in a new tab; clicks on other links or buttons are left alone. */
(function () {
  if (window.__wwTileLinks) return; window.__wwTileLinks = true;
  var body = document.body;
  if (!body || !/(^|\s)page(-|\s|$)/.test(body.className)) return;      /* Turbo puts the template name on <body>: "page", "page-accessories"… */
  var LABEL = /^(shop\s*now|magasiner(\s*maintenant)?|voir\s*la\s*collection|acheter)$/i;

  function tileOf(a) {
    var node = a.parentElement, tile = null;
    for (var depth = 0; node && node !== body && depth < 7; depth++, node = node.parentElement) {
      var links = node.querySelectorAll('a[href]');
      if (links.length !== 1) break;
      if (node.querySelector('img, h2, h3, h4, p')) tile = node;
    }
    return tile;
  }
  function wire() {
    var as = document.querySelectorAll('a[href]');
    for (var i = 0; i < as.length; i++) {
      var a = as[i];
      var txt = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!LABEL.test(txt)) continue;
      var tile = tileOf(a);
      if (!tile || tile.__wwTile) continue;
      tile.__wwTile = a;
      tile.classList.add('ww-tile-link');
      tile.setAttribute('data-ww-tile', '');
    }
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    var tile = e.target.closest && e.target.closest('[data-ww-tile]');
    if (!tile || !tile.__wwTile) return;
    if (e.target.closest('a, button, input, select, label')) return;   /* the real button / anything interactive keeps its own behaviour */
    var a = tile.__wwTile;
    if (e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') window.open(a.href, '_blank');
    else window.location.href = a.href;
  });
  document.addEventListener('auxclick', function (e) {              /* middle click → new tab */
    if (e.button !== 1) return;
    var tile = e.target.closest && e.target.closest('[data-ww-tile]');
    if (!tile || !tile.__wwTile || e.target.closest('a, button')) return;
    e.preventDefault(); window.open(tile.__wwTile.href, '_blank');
  });

  var css = document.createElement('style');
  css.textContent = '.ww-tile-link{cursor:pointer;transition:transform .15s ease,box-shadow .15s ease;border-radius:10px}' +
    '.ww-tile-link:hover{transform:translateY(-2px);box-shadow:0 10px 28px rgba(17,24,39,.10)}' +
    '.ww-tile-link:hover a{background:#111827!important;color:#fff!important;border-color:#111827!important}';
  document.head.appendChild(css);

  wire();
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(wire, 150); }).observe(document.body, { childList: true, subtree: true });
  }
})();


/* ---------- Product-page fitment widget: after a pick, the next dropdown opens by itself (Robert, 2026-10-01) ----------
   The widget's dropdowns are native <select>s (custom.css strips Convermax's shell). After Year is chosen Convermax
   re-renders and enables Make; we wait for that, then focus it and open its list (showPicker, where the browser
   allows it - Chrome, Edge, Firefox; Safari focuses it so one tap opens it). */
(function () {
  if (window.__wwYmmAdvance) return; window.__wwYmmAdvance = true;
  function selects() { return [].slice.call(document.querySelectorAll('#cm_verify-fitment select')); }
  function openNext(prev) {
    var all = selects(), i = all.indexOf(prev), tries = 0;
    var keyPrev = prev.name || prev.id || i;
    (function wait() {
      var now = selects(), idx = -1;
      for (var k = 0; k < now.length; k++) if ((now[k].name || now[k].id || k) === keyPrev) { idx = k; break; }
      if (idx === -1) idx = i;
      var next = now[idx + 1];
      if (next && !next.disabled && next.options && next.options.length > 1) {
        try { next.focus({ preventScroll: true }); } catch (e) { try { next.focus(); } catch (e2) {} }
        try { if (typeof next.showPicker === 'function') next.showPicker(); } catch (e) {}
        return;
      }
      if (++tries < 25) setTimeout(wait, 80);                              /* up to ~2 s for Convermax to enable it */
    })();
  }
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || sel.tagName !== 'SELECT' || !sel.closest('#cm_verify-fitment')) return;
    if (!sel.value || sel.selectedIndex <= 0) return;                     /* nothing chosen → nothing to advance to */
    setTimeout(function () { openNext(sel); }, 60);
  }, true);
})();
